import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TikTokRegular from './tiktok-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TikTokRegular {...validProps} />;
}
SvgComponent.iconName = 'tikTokRegular';

export const TikTokRegularIcon = svgIconWrapper(SvgComponent);
